import PropTypes from 'prop-types';

const SIZES = {
	sm: { outer: 'w-3.5 h-3.5', inner: 'w-1 h-1', label: 'text-xs' },
	md: { outer: 'w-4 h-4', inner: 'w-1.5 h-1.5', label: 'text-sm' },
	lg: { outer: 'w-5 h-5', inner: 'w-2 h-2', label: 'text-md' },
};

const RadioButton = ({
	id,
	name,
	value,
	checked = false,
	onChange,
	disabled = false,
	size = 'md',
	label,
	className = '',
	...props
}) => {
	const sizes = SIZES[size];

	return (
		<label
			className={`flex items-center gap-3 cursor-pointer group px-2 py-1.5 rounded-control transition-colors ${
				checked ? 'bg-primary-100' : 'hover:bg-bgBase-300'
			} ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`}
		>
			<div
				className={`${sizes.outer} rounded-full border-2 flex items-center justify-center transition-colors group-focus-within:ring-2 group-focus-within:ring-primary-200 ${
					checked ? 'border-primary-500 bg-primary-500' : 'border-bgBase-600 group-hover:border-primary-300'
				}`}
			>
				{checked && <div className={`${sizes.inner} rounded-full bg-white`} />}
			</div>
			{label && (
				<span
					className={`${sizes.label} transition-colors ${checked ? 'text-primary-700 font-medium' : 'text-text'}`}
				>
					{label}
				</span>
			)}
			<input
				type="radio"
				id={id}
				name={name}
				value={value}
				checked={checked}
				onChange={(e) => onChange?.(e.target.value)}
				disabled={disabled}
				className="sr-only"
				{...props}
			/>
		</label>
	);
};

RadioButton.propTypes = {
	id: PropTypes.string,
	name: PropTypes.string.isRequired,
	value: PropTypes.string.isRequired,
	checked: PropTypes.bool,
	onChange: PropTypes.func,
	disabled: PropTypes.bool,
	size: PropTypes.oneOf(['sm', 'md', 'lg']),
	label: PropTypes.node,
	className: PropTypes.string,
};

export default RadioButton;
